"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
var safe_1 = __importDefault(require("colors/safe"));
var isNodeJsContext = typeof globalThis.window === 'undefined';
var isMessageActionLike = function (message) { return 'action' in message; };
var logFn = function (_a) {
    var level = _a.level, label = _a.label, messages = _a.messages;
    var timestamp = new Date().toLocaleString();
    var getLevel = function () {
        switch (level) {
            case 'info': return safe_1.default.green(level);
            case 'warn': return safe_1.default.yellow(level);
            case 'error': return safe_1.default.red(level);
            case 'net': return safe_1.default.magenta(level);
        }
    };
    if (isNodeJsContext) {
        var getMessage = function () {
            return messages.map(function (message) {
                if (typeof message === 'string')
                    return message;
                if (isMessageActionLike(message)) {
                    var action = message.action, payload = message.payload;
                    return safe_1.default.bold(action) + " " + JSON.stringify(payload);
                }
                return JSON.stringify(message);
            }).join(' ');
        };
        var stream = level === 'error' || level === 'warn' ? process.stderr : process.stdout;
        stream.write(safe_1.default.grey(timestamp) + " - " + getLevel() + (label ? "[" + label + "]" : '') + ": " + getMessage() + "\n");
    }
    else {
        var getMessage = function () {
            return messages.flatMap(function (message) {
                if (typeof message === 'string')
                    return [message];
                if (isMessageActionLike(message)) {
                    var action = message.action, payload = message.payload;
                    return [safe_1.default.bold(action), payload];
                }
                return message;
            });
        };
        var stream = console[level === 'net' ? 'info' : level];
        stream.apply(void 0, __spreadArray([safe_1.default.grey(timestamp) + " " + getLevel() + (label ? "[" + label + "]" : '') + ":"], __read(getMessage())));
    }
};
exports.logger = {
    info: function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        logFn({
            level: 'info',
            messages: messages
        });
    },
    net: function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        logFn({
            level: 'net',
            messages: messages
        });
    },
    error: function (err) {
        var _a;
        if (!err.reason || err.reason === 'internal-error') {
            logFn({
                level: 'error',
                messages: [(_a = err.stack) !== null && _a !== void 0 ? _a : err + '']
            });
        }
        else {
            logFn({
                level: 'warn',
                messages: [err.stack
                        ? err.stack.split('\n').slice(0, 2).join('\n')
                        : err + '']
            });
        }
    },
    logDispatch: function (actionLikeList) {
        actionLikeList.forEach(function (actionLike) {
            logFn({
                level: 'info',
                messages: [actionLike]
            });
        });
    },
    logMessageReceived: function (actionLikeList) {
        actionLikeList.forEach(function (actionLike) {
            logFn({
                level: 'net',
                label: safe_1.default.brightMagenta.bold('in'),
                messages: [actionLike]
            });
        });
    },
    logMessageSent: function (actionLikeList) {
        actionLikeList.forEach(function (actionLike) {
            logFn({
                level: 'net',
                label: safe_1.default.magenta.bold('out'),
                messages: [actionLike]
            });
        });
    }
};
